import { IconName } from '@optimus-web/icons';
import { BannerVariant } from '@optimus-web/local-tokens';
import { TypographyOptions } from '../typography';
import {
    BannerCloseIcon,
    BannerElement,
    BannerIconElement,
    BannerInnerElement,
    PrimaryTextElement,
    SecondaryTextElement,
} from './style';

const iconNames: Record<BannerVariant, IconName> = {
    info: IconName.Info,
    success: IconName.CheckCircle,
    warning: IconName.Problematic,
    error: IconName.Blacklist,
};

export interface BannerProps {
    primaryText: React.ReactNode;
    variant: BannerVariant;
    centered?: boolean;
    onClose?: (event: React.MouseEvent<HTMLElement>) => void;
    secondaryText?: React.ReactNode;
    showIcon?: boolean;
    wordBreak?: TypographyOptions['wordBreak'];
}

const Banner = ({
    primaryText,
    variant = 'info',
    centered,
    onClose,
    secondaryText,
    showIcon = false,
    wordBreak,
    ...other
}: BannerProps) => (
    <BannerElement variant={variant} centered={centered} {...other}>
        <BannerInnerElement showIcon={showIcon}>
            {showIcon && <BannerIconElement value={iconNames[variant]} />}
            <div>
                <div>
                    <PrimaryTextElement hasSecondaryText={!!secondaryText} wordBreak={wordBreak}>
                        {primaryText}
                    </PrimaryTextElement>
                    {onClose && <BannerCloseIcon onClick={onClose} size="small" icon={IconName.CrossClose} />}
                </div>
                {!!secondaryText && <SecondaryTextElement wordBreak={wordBreak}>{secondaryText}</SecondaryTextElement>}
            </div>
        </BannerInnerElement>
    </BannerElement>
);

export default Banner;
